import React from 'react';

const FilterIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.66699 2.66667H13.3337V4.11467C13.3336 4.46826 13.1931 4.80735 12.943 5.05734L10.0003 8V12.6667L6.00033 14V8.33334L3.01366 5.048C2.79062 4.80262 2.66703 4.48294 2.66699 4.15134V2.66667Z",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
FilterIcon.displayName = "Icons.FilterIcon";

export { FilterIcon };
//# sourceMappingURL=FilterIcon.js.map
